import { toPairs } from 'rambda';
import { Refinements, RefinementItemsList } from '@packages/common';

export const mapFacetFiltersToRefinementItems =
  () =>
  (facetFilters: Refinements['facetFilters']): RefinementItemsList => {
    return toPairs(facetFilters).reduce((acc, [_, filter]) => {
      return {
        ...acc,
        [filter.seoName]: filter.values.map((item) => ({
          label: item.name,
          remove: () => {},
        })),
      };
    }, {} as RefinementItemsList);
  };

export const mapNumericFiltersToRefinementItems = () => (numericFilters: Refinements['numericFilters']) => {
  return toPairs(numericFilters).reduce((acc, [_, filter]) => {
    return {
      ...acc,
      [filter.seoName]: [
        {
          label: `${Object.values(filter.value).join(' - ')} ${filter.unit}`,
          remove: () => {},
        },
      ],
    };
  }, {} as RefinementItemsList);
};

export const mapRefinementsToRefinementItems = (refinements: Refinements): RefinementItemsList => {
  const { numericFilters, facetFilters } = refinements;

  return {
    ...mapNumericFiltersToRefinementItems()(numericFilters),
    ...mapFacetFiltersToRefinementItems()(facetFilters),
  };
};

export default mapRefinementsToRefinementItems;
